import { render, staticRenderFns } from "./CorporationsListTable.vue?vue&type=template&id=79d0f78b"
import script from "./CorporationsListTable.vue?vue&type=script&lang=js"
export * from "./CorporationsListTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports